module.exports = __webpack_public_path__ + "img/Minus.138e372c.svg";